/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Render_Audio_Converting_ToastInputs */



/**
* | output |
* | --- |
* | "Converting text to speech audio..." |
*
* @param {Render_Audio_Converting_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const render_audio_converting_toast = /** @type {((inputs?: Render_Audio_Converting_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Render_Audio_Converting_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Conversion du texte en audio...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Umwandlung von Text in Sprachausgabe...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Conversione del testo in audio vocale...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Преобразование текста в аудиозапись речи...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Convertir texto en audio de voz...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("将文本转换为语音音频...")
	if (locale === "ja") return /** @type {LocalizedString} */ ("テキストを音声オーディオに変換しています...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टेक्स्ट को ऑडियो स्पीच में परिवर्तित किया जा रहा है...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Converter texto em áudio de fala...")
	return /** @type {LocalizedString} */ ("Converting text to speech audio...")
});